/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const LocationApiBaseUrl = new InjectionToken<string>('LocationApiBaseUrl');

@Injectable({
    providedIn: 'root'
})
export class LocationsLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(LocationApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:5700";
    }

    getLocation(locationId: string): Observable<Location> {
        let url_ = this.baseUrl + "/locations/{location-id}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{location-id}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocation(<any>response_);
                } catch (e) {
                    return <Observable<Location>><any>_observableThrow(e);
                }
            } else
                return <Observable<Location>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocation(response: HttpResponseBase): Observable<Location> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Location.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Location>(<any>null);
    }

    getLocations(location_ids?: string[] | null | undefined, numbers?: string[] | null | undefined, state?: string | null | undefined, open_status_codes?: string[] | null | undefined, banner_ids?: string[] | null | undefined, hierarchy_level_id?: string | null | undefined, hierarchy_member_ids?: string[] | null | undefined, is_active?: boolean | null | undefined, is_visitable?: boolean | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfLocation> {
        let url_ = this.baseUrl + "/locations?";
        if (location_ids !== undefined && location_ids !== null)
            location_ids && location_ids.forEach(item => { url_ += "location_ids=" + encodeURIComponent("" + item) + "&"; });
        if (numbers !== undefined && numbers !== null)
            numbers && numbers.forEach(item => { url_ += "numbers=" + encodeURIComponent("" + item) + "&"; });
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (open_status_codes !== undefined && open_status_codes !== null)
            open_status_codes && open_status_codes.forEach(item => { url_ += "open_status_codes=" + encodeURIComponent("" + item) + "&"; });
        if (banner_ids !== undefined && banner_ids !== null)
            banner_ids && banner_ids.forEach(item => { url_ += "banner_ids=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchy_level_id !== undefined && hierarchy_level_id !== null)
            url_ += "hierarchy_level_id=" + encodeURIComponent("" + hierarchy_level_id) + "&";
        if (hierarchy_member_ids !== undefined && hierarchy_member_ids !== null)
            hierarchy_member_ids && hierarchy_member_ids.forEach(item => { url_ += "hierarchy_member_ids=" + encodeURIComponent("" + item) + "&"; });
        if (is_active !== undefined && is_active !== null)
            url_ += "is_active=" + encodeURIComponent("" + is_active) + "&";
        if (is_visitable !== undefined && is_visitable !== null)
            url_ += "is_visitable=" + encodeURIComponent("" + is_visitable) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfLocation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfLocation>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocations(response: HttpResponseBase): Observable<PaginationResponseOfLocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfLocation>(<any>null);
    }

    getLocationDistances(latitude?: number | null | undefined, longitude?: number | null | undefined, radius_miles?: number | null | undefined, is_visitable?: boolean | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfLocationDistance> {
        let url_ = this.baseUrl + "/locations/location-distances?";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (radius_miles !== undefined && radius_miles !== null)
            url_ += "radius_miles=" + encodeURIComponent("" + radius_miles) + "&";
        if (is_visitable !== undefined && is_visitable !== null)
            url_ += "is_visitable=" + encodeURIComponent("" + is_visitable) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationDistances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationDistances(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfLocationDistance>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfLocationDistance>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationDistances(response: HttpResponseBase): Observable<PaginationResponseOfLocationDistance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLocationDistance.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfLocationDistance>(<any>null);
    }

    getOpenStatuses(): Observable<OpenStatus[]> {
        let url_ = this.baseUrl + "/locations/open-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenStatuses(<any>response_);
                } catch (e) {
                    return <Observable<OpenStatus[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OpenStatus[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOpenStatuses(response: HttpResponseBase): Observable<OpenStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OpenStatus[]>(<any>null);
    }

    getBanners(): Observable<CollectionResponseOfBanner> {
        let url_ = this.baseUrl + "/locations/banners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanners(<any>response_);
                } catch (e) {
                    return <Observable<CollectionResponseOfBanner>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionResponseOfBanner>><any>_observableThrow(response_);
        }));
    }

    protected processGetBanners(response: HttpResponseBase): Observable<CollectionResponseOfBanner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionResponseOfBanner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionResponseOfBanner>(<any>null);
    }

    getHierarchyLevels(): Observable<CollectionResponseOfHierarchyLevel> {
        let url_ = this.baseUrl + "/locations/hierarchy-levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHierarchyLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHierarchyLevels(<any>response_);
                } catch (e) {
                    return <Observable<CollectionResponseOfHierarchyLevel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionResponseOfHierarchyLevel>><any>_observableThrow(response_);
        }));
    }

    protected processGetHierarchyLevels(response: HttpResponseBase): Observable<CollectionResponseOfHierarchyLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionResponseOfHierarchyLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionResponseOfHierarchyLevel>(<any>null);
    }

    getHierarchyMembers(hierarchy_level_id?: string | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfHierarchyMember> {
        let url_ = this.baseUrl + "/locations/hierarchy-members?";
        if (hierarchy_level_id !== undefined && hierarchy_level_id !== null)
            url_ += "hierarchy_level_id=" + encodeURIComponent("" + hierarchy_level_id) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHierarchyMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHierarchyMembers(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfHierarchyMember>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfHierarchyMember>><any>_observableThrow(response_);
        }));
    }

    protected processGetHierarchyMembers(response: HttpResponseBase): Observable<PaginationResponseOfHierarchyMember> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfHierarchyMember.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfHierarchyMember>(<any>null);
    }

    getLocation2(locationId: string): Observable<Location> {
        let url_ = this.baseUrl + "/v1/field-representatives/locations/{location-id}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{location-id}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocation2(<any>response_);
                } catch (e) {
                    return <Observable<Location>><any>_observableThrow(e);
                }
            } else
                return <Observable<Location>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocation2(response: HttpResponseBase): Observable<Location> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Location.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Location>(<any>null);
    }

    getLocations2(location_ids?: string[] | null | undefined, numbers?: string[] | null | undefined, state?: string | null | undefined, open_status_codes?: string[] | null | undefined, banner_ids?: string[] | null | undefined, hierarchy_level_id?: string | null | undefined, hierarchy_member_ids?: string[] | null | undefined, is_active?: boolean | null | undefined, is_visitable?: boolean | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfLocation> {
        let url_ = this.baseUrl + "/v1/field-representatives/locations?";
        if (location_ids !== undefined && location_ids !== null)
            location_ids && location_ids.forEach(item => { url_ += "location_ids=" + encodeURIComponent("" + item) + "&"; });
        if (numbers !== undefined && numbers !== null)
            numbers && numbers.forEach(item => { url_ += "numbers=" + encodeURIComponent("" + item) + "&"; });
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (open_status_codes !== undefined && open_status_codes !== null)
            open_status_codes && open_status_codes.forEach(item => { url_ += "open_status_codes=" + encodeURIComponent("" + item) + "&"; });
        if (banner_ids !== undefined && banner_ids !== null)
            banner_ids && banner_ids.forEach(item => { url_ += "banner_ids=" + encodeURIComponent("" + item) + "&"; });
        if (hierarchy_level_id !== undefined && hierarchy_level_id !== null)
            url_ += "hierarchy_level_id=" + encodeURIComponent("" + hierarchy_level_id) + "&";
        if (hierarchy_member_ids !== undefined && hierarchy_member_ids !== null)
            hierarchy_member_ids && hierarchy_member_ids.forEach(item => { url_ += "hierarchy_member_ids=" + encodeURIComponent("" + item) + "&"; });
        if (is_active !== undefined && is_active !== null)
            url_ += "is_active=" + encodeURIComponent("" + is_active) + "&";
        if (is_visitable !== undefined && is_visitable !== null)
            url_ += "is_visitable=" + encodeURIComponent("" + is_visitable) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocations2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocations2(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfLocation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfLocation>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocations2(response: HttpResponseBase): Observable<PaginationResponseOfLocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfLocation>(<any>null);
    }

    getLocationDistances2(latitude?: number | null | undefined, longitude?: number | null | undefined, radius_miles?: number | null | undefined, is_visitable?: boolean | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfLocationDistance> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-distances?";
        if (latitude !== undefined && latitude !== null)
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude !== undefined && longitude !== null)
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (radius_miles !== undefined && radius_miles !== null)
            url_ += "radius_miles=" + encodeURIComponent("" + radius_miles) + "&";
        if (is_visitable !== undefined && is_visitable !== null)
            url_ += "is_visitable=" + encodeURIComponent("" + is_visitable) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationDistances2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationDistances2(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfLocationDistance>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfLocationDistance>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationDistances2(response: HttpResponseBase): Observable<PaginationResponseOfLocationDistance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfLocationDistance.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfLocationDistance>(<any>null);
    }

    getOpenStatuses2(): Observable<OpenStatus[]> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-open-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenStatuses2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenStatuses2(<any>response_);
                } catch (e) {
                    return <Observable<OpenStatus[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OpenStatus[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOpenStatuses2(response: HttpResponseBase): Observable<OpenStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpenStatus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OpenStatus[]>(<any>null);
    }

    getBanners2(): Observable<CollectionResponseOfBanner> {
        let url_ = this.baseUrl + "/v1/field-representatives/banners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBanners2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBanners2(<any>response_);
                } catch (e) {
                    return <Observable<CollectionResponseOfBanner>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionResponseOfBanner>><any>_observableThrow(response_);
        }));
    }

    protected processGetBanners2(response: HttpResponseBase): Observable<CollectionResponseOfBanner> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionResponseOfBanner.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionResponseOfBanner>(<any>null);
    }

    getHierarchyLevels2(): Observable<CollectionResponseOfHierarchyLevel> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-hierarchy-levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHierarchyLevels2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHierarchyLevels2(<any>response_);
                } catch (e) {
                    return <Observable<CollectionResponseOfHierarchyLevel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionResponseOfHierarchyLevel>><any>_observableThrow(response_);
        }));
    }

    protected processGetHierarchyLevels2(response: HttpResponseBase): Observable<CollectionResponseOfHierarchyLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionResponseOfHierarchyLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionResponseOfHierarchyLevel>(<any>null);
    }

    getHierarchyMembers2(hierarchy_level_id?: string | null | undefined, offset?: number | undefined, limit?: number | undefined, sort?: string | null | undefined): Observable<PaginationResponseOfHierarchyMember> {
        let url_ = this.baseUrl + "/v1/field-representatives/location-hierarchy-members?";
        if (hierarchy_level_id !== undefined && hierarchy_level_id !== null)
            url_ += "hierarchy_level_id=" + encodeURIComponent("" + hierarchy_level_id) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHierarchyMembers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHierarchyMembers2(<any>response_);
                } catch (e) {
                    return <Observable<PaginationResponseOfHierarchyMember>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaginationResponseOfHierarchyMember>><any>_observableThrow(response_);
        }));
    }

    protected processGetHierarchyMembers2(response: HttpResponseBase): Observable<PaginationResponseOfHierarchyMember> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginationResponseOfHierarchyMember.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaginationResponseOfHierarchyMember>(<any>null);
    }

    getBannerConfigurations(is_visitable?: boolean | null | undefined): Observable<CollectionResponseOfBannerConfiguration> {
        let url_ = this.baseUrl + "/v1/field-representatives/banner-configurations?";
        if (is_visitable !== undefined && is_visitable !== null)
            url_ += "is_visitable=" + encodeURIComponent("" + is_visitable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBannerConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBannerConfigurations(<any>response_);
                } catch (e) {
                    return <Observable<CollectionResponseOfBannerConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionResponseOfBannerConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processGetBannerConfigurations(response: HttpResponseBase): Observable<CollectionResponseOfBannerConfiguration> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionResponseOfBannerConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionResponseOfBannerConfiguration>(<any>null);
    }
}

export class Location implements ILocation {
    location_id?: string;
    number?: string;
    banner?: Banner | null;
    physical_address?: Address | null;
    mailing_address?: Address | null;
    latitude?: number | null;
    longitude?: number | null;
    is_active?: boolean;
    time_zone?: TimeZone | null;
    open_date?: moment.Moment;
    open_status?: OpenStatus | null;
    contact?: Contact | null;
    hierarchy_members?: HierarchyMember[] | null;
    division?: Division | null;
    geo_region?: GeoRegion | null;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location_id = _data["location_id"] !== undefined ? _data["location_id"] : <any>null;
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.banner = _data["banner"] ? Banner.fromJS(_data["banner"]) : <any>null;
            this.physical_address = _data["physical_address"] ? Address.fromJS(_data["physical_address"]) : <any>null;
            this.mailing_address = _data["mailing_address"] ? Address.fromJS(_data["mailing_address"]) : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.is_active = _data["is_active"] !== undefined ? _data["is_active"] : <any>null;
            this.time_zone = _data["time_zone"] ? TimeZone.fromJS(_data["time_zone"]) : <any>null;
            this.open_date = _data["open_date"] ? moment(_data["open_date"].toString()) : <any>null;
            this.open_status = _data["open_status"] ? OpenStatus.fromJS(_data["open_status"]) : <any>null;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>null;
            if (Array.isArray(_data["hierarchy_members"])) {
                this.hierarchy_members = [] as any;
                for (let item of _data["hierarchy_members"])
                    this.hierarchy_members!.push(HierarchyMember.fromJS(item));
            }
            else {
                this.hierarchy_members = <any>null;
            }
            this.division = _data["division"] ? Division.fromJS(_data["division"]) : <any>null;
            this.geo_region = _data["geo_region"] ? GeoRegion.fromJS(_data["geo_region"]) : <any>null;
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location_id"] = this.location_id !== undefined ? this.location_id : <any>null;
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["banner"] = this.banner ? this.banner.toJSON() : <any>null;
        data["physical_address"] = this.physical_address ? this.physical_address.toJSON() : <any>null;
        data["mailing_address"] = this.mailing_address ? this.mailing_address.toJSON() : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["is_active"] = this.is_active !== undefined ? this.is_active : <any>null;
        data["time_zone"] = this.time_zone ? this.time_zone.toJSON() : <any>null;
        data["open_date"] = this.open_date ? this.open_date.toISOString() : <any>null;
        data["open_status"] = this.open_status ? this.open_status.toJSON() : <any>null;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>null;
        if (Array.isArray(this.hierarchy_members)) {
            data["hierarchy_members"] = [];
            for (let item of this.hierarchy_members)
                data["hierarchy_members"].push(item.toJSON());
        }
        data["division"] = this.division ? this.division.toJSON() : <any>null;
        data["geo_region"] = this.geo_region ? this.geo_region.toJSON() : <any>null;
        return data;
    }

    clone(): Location {
        const json = this.toJSON();
        let result = new Location();
        result.init(json);
        return result;
    }
}

export interface ILocation {
    location_id?: string;
    number?: string;
    banner?: Banner | null;
    physical_address?: Address | null;
    mailing_address?: Address | null;
    latitude?: number | null;
    longitude?: number | null;
    is_active?: boolean;
    time_zone?: TimeZone | null;
    open_date?: moment.Moment;
    open_status?: OpenStatus | null;
    contact?: Contact | null;
    hierarchy_members?: HierarchyMember[] | null;
    division?: Division | null;
    geo_region?: GeoRegion | null;
}

export class Banner implements IBanner {
    banner_id?: string;
    code?: string;
    name?: string;

    constructor(data?: IBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.banner_id = _data["banner_id"] !== undefined ? _data["banner_id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): Banner {
        data = typeof data === 'object' ? data : {};
        let result = new Banner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banner_id"] = this.banner_id !== undefined ? this.banner_id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): Banner {
        const json = this.toJSON();
        let result = new Banner();
        result.init(json);
        return result;
    }
}

export interface IBanner {
    banner_id?: string;
    code?: string;
    name?: string;
}

export class Address implements IAddress {
    address_line1?: string;
    address_line2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: Country | null;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address_line1 = _data["address_line1"] !== undefined ? _data["address_line1"] : <any>null;
            this.address_line2 = _data["address_line2"] !== undefined ? _data["address_line2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>null;
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address_line1"] = this.address_line1 !== undefined ? this.address_line1 : <any>null;
        data["address_line2"] = this.address_line2 !== undefined ? this.address_line2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    address_line1?: string;
    address_line2?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: Country | null;
}

export class Country implements ICountry {
    code?: string;
    name?: string;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    code?: string;
    name?: string;
}

export class TimeZone implements ITimeZone {
    name?: string;
    id?: string;
    code?: string;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }

    clone(): TimeZone {
        const json = this.toJSON();
        let result = new TimeZone();
        result.init(json);
        return result;
    }
}

export interface ITimeZone {
    name?: string;
    id?: string;
    code?: string;
}

export class OpenStatus implements IOpenStatus {
    code?: string;
    description?: string;
    group_name?: string;

    constructor(data?: IOpenStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.group_name = _data["group_name"] !== undefined ? _data["group_name"] : <any>null;
        }
    }

    static fromJS(data: any): OpenStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OpenStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["group_name"] = this.group_name !== undefined ? this.group_name : <any>null;
        return data;
    }

    clone(): OpenStatus {
        const json = this.toJSON();
        let result = new OpenStatus();
        result.init(json);
        return result;
    }
}

export interface IOpenStatus {
    code?: string;
    description?: string;
    group_name?: string;
}

export class Contact implements IContact {
    phone_number?: string | null;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone_number = _data["phone_number"] !== undefined ? _data["phone_number"] : <any>null;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone_number"] = this.phone_number !== undefined ? this.phone_number : <any>null;
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    phone_number?: string | null;
}

export class HierarchyMember implements IHierarchyMember {
    hierarchy_level_id?: string;
    hierarchy_member_id?: string;
    code?: string;
    name?: string;
    manager?: Manager | null;

    constructor(data?: IHierarchyMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hierarchy_level_id = _data["hierarchy_level_id"] !== undefined ? _data["hierarchy_level_id"] : <any>null;
            this.hierarchy_member_id = _data["hierarchy_member_id"] !== undefined ? _data["hierarchy_member_id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.manager = _data["manager"] ? Manager.fromJS(_data["manager"]) : <any>null;
        }
    }

    static fromJS(data: any): HierarchyMember {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hierarchy_level_id"] = this.hierarchy_level_id !== undefined ? this.hierarchy_level_id : <any>null;
        data["hierarchy_member_id"] = this.hierarchy_member_id !== undefined ? this.hierarchy_member_id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["manager"] = this.manager ? this.manager.toJSON() : <any>null;
        return data;
    }

    clone(): HierarchyMember {
        const json = this.toJSON();
        let result = new HierarchyMember();
        result.init(json);
        return result;
    }
}

export interface IHierarchyMember {
    hierarchy_level_id?: string;
    hierarchy_member_id?: string;
    code?: string;
    name?: string;
    manager?: Manager | null;
}

export class Manager implements IManager {
    name?: Name | null;

    constructor(data?: IManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] ? Name.fromJS(_data["name"]) : <any>null;
        }
    }

    static fromJS(data: any): Manager {
        data = typeof data === 'object' ? data : {};
        let result = new Manager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        return data;
    }

    clone(): Manager {
        const json = this.toJSON();
        let result = new Manager();
        result.init(json);
        return result;
    }
}

export interface IManager {
    name?: Name | null;
}

export class Name implements IName {
    full_name?: string | null;

    constructor(data?: IName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.full_name = _data["full_name"] !== undefined ? _data["full_name"] : <any>null;
        }
    }

    static fromJS(data: any): Name {
        data = typeof data === 'object' ? data : {};
        let result = new Name();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["full_name"] = this.full_name !== undefined ? this.full_name : <any>null;
        return data;
    }

    clone(): Name {
        const json = this.toJSON();
        let result = new Name();
        result.init(json);
        return result;
    }
}

export interface IName {
    full_name?: string | null;
}

export class Division implements IDivision {
    code?: string;
    name?: string;

    constructor(data?: IDivision) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): Division {
        data = typeof data === 'object' ? data : {};
        let result = new Division();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): Division {
        const json = this.toJSON();
        let result = new Division();
        result.init(json);
        return result;
    }
}

export interface IDivision {
    code?: string;
    name?: string;
}

export class GeoRegion implements IGeoRegion {
    code?: string;
    name?: string;

    constructor(data?: IGeoRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): GeoRegion {
        data = typeof data === 'object' ? data : {};
        let result = new GeoRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): GeoRegion {
        const json = this.toJSON();
        let result = new GeoRegion();
        result.init(json);
        return result;
    }
}

export interface IGeoRegion {
    code?: string;
    name?: string;
}

export class PaginationResponseOfLocation implements IPaginationResponseOfLocation {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: Location[];

    constructor(data?: IPaginationResponseOfLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.total_count = _data["total_count"] !== undefined ? _data["total_count"] : <any>null;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Location.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PaginationResponseOfLocation {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["total_count"] = this.total_count !== undefined ? this.total_count : <any>null;
        data["sort"] = this.sort !== undefined ? this.sort : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginationResponseOfLocation {
        const json = this.toJSON();
        let result = new PaginationResponseOfLocation();
        result.init(json);
        return result;
    }
}

export interface IPaginationResponseOfLocation {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: Location[];
}

export class PaginationResponseOfLocationDistance implements IPaginationResponseOfLocationDistance {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: LocationDistance[];

    constructor(data?: IPaginationResponseOfLocationDistance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.total_count = _data["total_count"] !== undefined ? _data["total_count"] : <any>null;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationDistance.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PaginationResponseOfLocationDistance {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfLocationDistance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["total_count"] = this.total_count !== undefined ? this.total_count : <any>null;
        data["sort"] = this.sort !== undefined ? this.sort : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginationResponseOfLocationDistance {
        const json = this.toJSON();
        let result = new PaginationResponseOfLocationDistance();
        result.init(json);
        return result;
    }
}

export interface IPaginationResponseOfLocationDistance {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: LocationDistance[];
}

export class LocationDistance implements ILocationDistance {
    distance_miles?: number;
    location?: Location;

    constructor(data?: ILocationDistance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distance_miles = _data["distance_miles"] !== undefined ? _data["distance_miles"] : <any>null;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>null;
        }
    }

    static fromJS(data: any): LocationDistance {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDistance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distance_miles"] = this.distance_miles !== undefined ? this.distance_miles : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        return data;
    }

    clone(): LocationDistance {
        const json = this.toJSON();
        let result = new LocationDistance();
        result.init(json);
        return result;
    }
}

export interface ILocationDistance {
    distance_miles?: number;
    location?: Location;
}

export class CollectionResponseOfBanner implements ICollectionResponseOfBanner {
    items?: Banner[];

    constructor(data?: ICollectionResponseOfBanner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Banner.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): CollectionResponseOfBanner {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionResponseOfBanner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CollectionResponseOfBanner {
        const json = this.toJSON();
        let result = new CollectionResponseOfBanner();
        result.init(json);
        return result;
    }
}

export interface ICollectionResponseOfBanner {
    items?: Banner[];
}

export class CollectionResponseOfHierarchyLevel implements ICollectionResponseOfHierarchyLevel {
    items?: HierarchyLevel[];

    constructor(data?: ICollectionResponseOfHierarchyLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HierarchyLevel.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): CollectionResponseOfHierarchyLevel {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionResponseOfHierarchyLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CollectionResponseOfHierarchyLevel {
        const json = this.toJSON();
        let result = new CollectionResponseOfHierarchyLevel();
        result.init(json);
        return result;
    }
}

export interface ICollectionResponseOfHierarchyLevel {
    items?: HierarchyLevel[];
}

export class HierarchyLevel implements IHierarchyLevel {
    hierarchy_level_id?: string;
    name?: string;

    constructor(data?: IHierarchyLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hierarchy_level_id = _data["hierarchy_level_id"] !== undefined ? _data["hierarchy_level_id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): HierarchyLevel {
        data = typeof data === 'object' ? data : {};
        let result = new HierarchyLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hierarchy_level_id"] = this.hierarchy_level_id !== undefined ? this.hierarchy_level_id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): HierarchyLevel {
        const json = this.toJSON();
        let result = new HierarchyLevel();
        result.init(json);
        return result;
    }
}

export interface IHierarchyLevel {
    hierarchy_level_id?: string;
    name?: string;
}

export class PaginationResponseOfHierarchyMember implements IPaginationResponseOfHierarchyMember {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: HierarchyMember[];

    constructor(data?: IPaginationResponseOfHierarchyMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.total_count = _data["total_count"] !== undefined ? _data["total_count"] : <any>null;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HierarchyMember.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): PaginationResponseOfHierarchyMember {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationResponseOfHierarchyMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["total_count"] = this.total_count !== undefined ? this.total_count : <any>null;
        data["sort"] = this.sort !== undefined ? this.sort : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PaginationResponseOfHierarchyMember {
        const json = this.toJSON();
        let result = new PaginationResponseOfHierarchyMember();
        result.init(json);
        return result;
    }
}

export interface IPaginationResponseOfHierarchyMember {
    offset?: number;
    limit?: number;
    total_count?: number | null;
    sort?: string | null;
    items?: HierarchyMember[];
}

export class CollectionResponseOfBannerConfiguration implements ICollectionResponseOfBannerConfiguration {
    items?: BannerConfiguration[];

    constructor(data?: ICollectionResponseOfBannerConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BannerConfiguration.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): CollectionResponseOfBannerConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionResponseOfBannerConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CollectionResponseOfBannerConfiguration {
        const json = this.toJSON();
        let result = new CollectionResponseOfBannerConfiguration();
        result.init(json);
        return result;
    }
}

export interface ICollectionResponseOfBannerConfiguration {
    items?: BannerConfiguration[];
}

export class BannerConfiguration implements IBannerConfiguration {
    banner_configuration_id?: string;
    banner_id?: string;
    is_visitable?: boolean;

    constructor(data?: IBannerConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.banner_configuration_id = _data["banner_configuration_id"] !== undefined ? _data["banner_configuration_id"] : <any>null;
            this.banner_id = _data["banner_id"] !== undefined ? _data["banner_id"] : <any>null;
            this.is_visitable = _data["is_visitable"] !== undefined ? _data["is_visitable"] : <any>null;
        }
    }

    static fromJS(data: any): BannerConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new BannerConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banner_configuration_id"] = this.banner_configuration_id !== undefined ? this.banner_configuration_id : <any>null;
        data["banner_id"] = this.banner_id !== undefined ? this.banner_id : <any>null;
        data["is_visitable"] = this.is_visitable !== undefined ? this.is_visitable : <any>null;
        return data;
    }

    clone(): BannerConfiguration {
        const json = this.toJSON();
        let result = new BannerConfiguration();
        result.init(json);
        return result;
    }
}

export interface IBannerConfiguration {
    banner_configuration_id?: string;
    banner_id?: string;
    is_visitable?: boolean;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}